import { render, staticRenderFns } from "./avatar-choose-dialog.vue?vue&type=template&id=90da3b64&scoped=true"
import script from "./avatar-choose-dialog.vue?vue&type=script&lang=js"
export * from "./avatar-choose-dialog.vue?vue&type=script&lang=js"
import style0 from "./avatar-choose-dialog.vue?vue&type=style&index=0&id=90da3b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da3b64",
  null
  
)

export default component.exports